import React, { useEffect, useState, useRef } from 'react';
import brandOffline from '../../assets/images/brand/brand_offline.png';

const BrandOffline = () => {
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        } else {
          setIsVisible(false);
        }
      },
      {
        threshold: 0.05,
        rootMargin: '-20px'
      }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);

  return (
    <section ref={sectionRef} className="w-full flex justify-center bg-[#FEF1F9] py-[100px] md:py-[160px]">
      <div className="w-full flex flex-col-reverse md:flex-row items-center justify-between">
        {/* 왼쪽 이미지 */}
        <div 
          className={`w-full pt-[30px] md:pt-[0px] md:w-1/2 flex justify-center md:justify-end items-center mb-[5px] md:mb-0 mt-[5px] md:mt-0 transition-all duration-[2000ms] [transition-timing-function:cubic-bezier(0.4,0,0.2,1)] ${isVisible ? 'opacity-100' : 'opacity-0'}`}>
          <img
            src={brandOffline}
            alt="오프라인 매장 이미지"
            className="w-[360px] md:w-[740px] h-[250px] md:h-[514px] object-cover"
          />
        </div>
        {/* 오른쪽 텍스트 */}
        <div 
          className={`w-full md:w-1/2 flex flex-col justify-center items-center md:items-start px-4 md:px-[120px] space-y-[16px] md:space-y-[50px] transition-all duration-[2000ms] [transition-timing-function:cubic-bezier(0.4,0,0.2,1)] ${isVisible ? 'opacity-100' : 'opacity-0'}`}
        >
          <div className="text-[#A019B2] text-[18px] md:text-[24px] leading-[160%] font-pretendard text-center md:text-left mb-4 md:mb-0">
            스마트한 렌즈 탐색
          </div>
          <h2 className="text-[24px] md:text-[40px] leading-[140%] font-pretendard font-bold text-black text-center md:text-left">
            폰피쉬 오프라인 매장 및<br />돈키호테 입점 브랜드 보유
          </h2>
          <p className="text-[16px] md:text-[20px] leading-[160%] font-pretendard text-black text-center md:text-left">
            현지 오프라인 유통망과 함께<br />브랜드의 해외 진출을 실질적으로 이끌어줍니다.
          </p>
        </div>
      </div>
    </section>
  );
};

export default BrandOffline; 